// extracted by mini-css-extract-plugin
export default {"wrapper":"custom-notice-bar_wrapper__QsxK8","alert":"custom-notice-bar_alert__aREgN","show":"custom-notice-bar_show__4svgG"};